import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { BookingSessionsData } from '../../@type/booking-sessions';
import { getErrorMessage } from '@/utils/stringHelper';

// ----------------------------------------------------------------------

type BookingSessionsState = {
  isLoading: boolean;
  error: boolean;
  bookingSessionsList: BookingSessionsData[];
};

const initialState: BookingSessionsState = {
  isLoading: false,
  error: false,
  bookingSessionsList: []
};

const slice = createSlice({
  name: 'booking-sessions',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state: BookingSessionsState) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state: BookingSessionsState, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = Boolean(action.payload);
    },

    // GET PROMOTIONS
    getBookingsSessionsSuccess(state: BookingSessionsState, action: PayloadAction<BookingSessionsData[]>) {
      state.isLoading = false;
      state.bookingSessionsList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;
export const { getBookingsSessionsSuccess } = slice.actions;

// Actions

// ----------------------------------------------------------------------

export function getBookingSessionsList(): () => Promise<void> {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/booking-sessions/all');
      dispatch(slice.actions.getBookingsSessionsSuccess(response.data.bookings));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch(slice.actions.hasError(errorMessage));
    }
  };
}
